import { MysteryWinSplash, useMessageData } from '@amusnet/react-ui'
import { useConfigurationStore } from '@stores/configurationStore'
import {
    GameUIMessageType,
    MysteryWinAnimationCompleteMessage,
    MysteryWinAwardedMessage,
    MysteryWinMoneyAnimationCompleteMessage,
    ViewportType,
} from 'game-ui-types'
import React, { useState } from 'react'

const MysteryWin: React.FC = () => {
    const hideCents = useConfigurationStore((state) => state.currencyHideCents)
    const currency = useConfigurationStore((state) => state.currency)
    const viewport = useConfigurationStore((state) => state.viewport)
    const useMysteryTextVariant = useConfigurationStore((state) => state.useMysteryTextVariant)
    const [showSplash, setShowSplash] = useState(false)
    const [amount, setAmount] = useState(0)
    const [duration, setDuration] = useState(3)

    useMessageData((rawData) => {
        const { type } = rawData

        switch (type) {
            case GameUIMessageType.MYSTERY_WIN_AWARDED: {
                const { amount: winAmount, seconds } = rawData as MysteryWinAwardedMessage

                setAmount(winAmount)
                setDuration(seconds ?? 3)
                setShowSplash(true)
                break
            }
        }
    })

    if (!showSplash) return null

    const onWinMoneyAnimationComplete = () => {
        const mysteryWinMoneyAnimationCompleteMessage: MysteryWinMoneyAnimationCompleteMessage = {
            type: GameUIMessageType.MYSTERY_WIN_MONEY_ANIMATION_COMPLETE,
        }

        window.uiBus.postMessage(mysteryWinMoneyAnimationCompleteMessage)
    }

    const onAnimationComplete = () => {
        const mysteryWinAnimationCompleteMessage: MysteryWinAnimationCompleteMessage = {
            type: GameUIMessageType.MYSTERY_WIN_ANIMATION_COMPLETE,
        }

        window.uiBus.postMessage(mysteryWinAnimationCompleteMessage)

        setShowSplash(false)
    }

    return (
        <MysteryWinSplash
            className="z-[1000]"
            amount={amount}
            hideCents={hideCents}
            timings={{ countUp: duration }}
            currency={currency}
            useMysteryVariant={useMysteryTextVariant}
            isPortrait={viewport === ViewportType.MOBILE_PORTRAIT}
            onWinMoneyAnimationComplete={onWinMoneyAnimationComplete}
            onAnimationComplete={onAnimationComplete}
        />
    )
}

export default MysteryWin
